// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.page-wrapper[data-v-3da4cf12] {\n  padding: 20px 30px;\n  min-height: 500px;\n  background: #fff;\n}\n[data-v-3da4cf12] .el-table tr th {\n  color: #333;\n  background: #f5f5f5 !important;\n}\n.imFile[data-v-3da4cf12] {\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
